
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/healer/signin",
      function () {
        return require("private-next-pages/auth/healer/signin.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/healer/signin"])
      });
    }
  